import FormSandbox from 'root/main/components/forms/ui/formSandbox';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import Events from 'root/helpers/events';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import FormControllerInit from 'root/main/components/forms/formControllerInit';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import {
    FormGTMObjectConstructor,
    getPlacement,
} from 'root/utils/tracking/GA4/formTracking';
import afterIntercomHasLoaded from 'root/utils/afterIntercomHasLoaded';
import { getHashFromURL } from 'root/utils/url/urlUtils';
import React from 'react';
import ReactDOM from 'react-dom';
import Loader from 'root/main/components/loader/loader';

/* it is important for these default vars initialization to be outside of the default function so that they don't get set and the form lightbox will lose its current state */
let formSandboxes = {};
let wrapper = null;
let targetFile = null;
let lsForm = null;
let formGTMObjectConstructor = null;

export default function FormSandboxCtl() {
    const body = document.body;
    const importUIToFormSandbox = formEl => {
        import(
            /*webpackChunkName: "[request]"*/ 'root/main/components/forms/ui/deprecated/oldFormUI'
        )
            .then(module => {
                const ui = new module.default(formEl);
                return ui.loadFormSpecs();
            })
            .then(() => {
                const dropdowns = formEl.querySelectorAll('select.gb-form__field-text');
                dropdowns.forEach(dropdown => {
                    if (dropdown.parentElement.classList.contains('js-field-valid')) {
                        dropdown.parentElement.classList.remove('js-field-valid');
                    }
                });
            });
    };

    const importTooltipsFile = formEl => {
        import(
            /*webpackChunkName: "[request]"*/ 'root/main/components/tooltip/tooltip'
        ).then(module => {
            const tooltips = formEl.querySelectorAll('[data-tooltip]');
            module.default(tooltips);
        });
    };

    const formSandboxCallback = event => {
        lsForm = formSandboxes[targetFile].element?.querySelector(
            '[data-form*="ls-form"]'
        );
        const formSandboxLoaded = new CustomEvent('formSandboxLoaded');
        if (lsForm) {
            /* this custom event is used in the email only for triggering actions when the lightbox has been initialized */
            Events.fire('formSandboxOpened');
            document.body.dispatchEvent(formSandboxLoaded);

            /* We are dynamically importing this here because once a new form is created inside the lightbox, it will not
            have access to formController if it has not been initialized previously on the page may be due to the absence
            of a submit button. By this we are ensuring no matter what that the formController will be initialized inside the lightbox. */

            FormControllerInit(lsForm);

            import(
                /*webpackChunkName: "agnosticFormController"*/ 'root/main/components/forms/agnosticFormControllerInit'
            ).then(module => module.default(lsForm));

            lsForm.dataset.formPlacement =
                event && event.target ? getPlacement(event.target) : getPlacement(lsForm);

            importUIToFormSandbox(lsForm);
            importTooltipsFile(lsForm);

            formGTMObjectConstructor = new FormGTMObjectConstructor(lsForm);
            gtm.form(lsForm).sendEvent('form_sandbox_open');
            GoogleTagManager.sendEvent(
                formGTMObjectConstructor.getFormGTMObject('form_sandbox_open')
            );
        } else {
            LoggingHandler().logError(
                `leadform: form element is undefined on uri: ${window.location.pathname.substring(
                    1
                )}`,
                {
                    searchTerm: 'form-sandbox-forms-error',
                    tags: ['forms'],
                    fileName: 'formSandboxCtl.js',
                }
            );
        }
        show(targetFile);
    };

    const clickHandler = e => {
        setFormSandboxLightboxWrapper();
        const formSandboxController = new FormSandbox(targetFile, wrapper);
        formSandboxController.load(formSandboxCallback, e);
        formSandboxes[targetFile] = formSandboxController;
    };

    const setFormSandboxLightboxWrapper = () => {
        const existingLightboxWrapper = document.querySelector('.js-lightbox-wrapper');
        if (existingLightboxWrapper) existingLightboxWrapper.remove();
        const n = document.createElement('div');
        n.classList.add('js-lightbox-wrapper', 'js-leadform-form-sandbox');
        showWaitingSpinner(n);
        buildFormSandboxLayoutHTML(n);
    };

    const buildFormSandboxLayoutHTML = n => {
        // build wrapper for the bg button & the modal
        const overlayWrapper = body.insertBefore(n, body.firstChild);

        // build the modal content wrapper & add to the parent wrapper
        const modalContentWrapper = document.createElement('div');
        wrapper = overlayWrapper.insertBefore(
            modalContentWrapper,
            overlayWrapper.firstChild
        );

        // set transitions on siteContent wrapper
        const siteContent = document.querySelector('#page');
        if (siteContent) {
            siteContent.classList.add('tw:transition-[filter]', 'tw:duration-150');
            siteContent.classList.add('tw:blur-[25px]', 'tw:overflow-hidden');
            siteContent.setAttribute('inert', '');
        }
    };

    const addModalCloseButton = () => {
        const closeBtn = document.createElement('button');
        closeBtn.classList.add('js-leadform-form-sandbox__modal__close-btn');
        closeBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24"/>
                <path d="M10.6122 11.9999L6.3999 7.78758L7.78757 6.3999L11.9999 10.6122L16.2122 6.3999L17.5999 7.78758L13.3876 11.9999L17.5999 16.2122L16.2122 17.5999L11.9999 13.3876L7.7876 17.5999L6.39993 16.2122L10.6122 11.9999Z" fill="#191513"/>
            </svg>
        `;
        closeBtn.setAttribute('type', 'button');
        closeBtn.setAttribute('aria-label', 'Close pop-up');
        wrapper.insertBefore(closeBtn, wrapper.firstElementChild);
        closeBtn.addEventListener('click', hide);
    };

    const show = () => {
        body.classList.add('js-show-lightbox', 'js-show-form-sandbox');
        formSandboxes[targetFile].show();
        if (wrapper) {
            wrapper.style.display = 'flex';
        }
        afterIntercomHasLoaded(toggleIntercomDisplay);
        addModalCloseButton();
        hideWaitingSpinner(wrapper.parentElement);
    };

    const hide = () => {
        body.classList.remove('js-show-lightbox', 'js-show-form-sandbox');
        const siteContent = document.querySelector('#page');
        if (siteContent) {
            siteContent.classList.remove('tw:blur-[25px]', 'tw:overflow-hidden');
            siteContent.classList.remove('tw:transition-[filter]', 'tw:duration-150');
            siteContent.removeAttribute('inert');
        }
        if (wrapper) {
            wrapper.parentElement.style.display = 'none';
            wrapper.style.display = 'none';
        }
        for (let key in formSandboxes) {
            if (!Object.prototype.hasOwnProperty.call(formSandboxes, key)) continue;
            formSandboxes[key].hide();
        }
        gtm.form(lsForm).sendEvent('form-sandbox-closed');
        if (formGTMObjectConstructor) {
            GoogleTagManager.sendEvent(
                formGTMObjectConstructor.getFormGTMObject('form_sandbox_closed')
            );
        }
        afterIntercomHasLoaded(() => toggleIntercomDisplay(false));

        document.removeEventListener('keydown', escapeHandler);
    };

    const toggleIntercomDisplay = (hide = true) => {
        const intercom = document.querySelector(
            '.intercom-lightweight-app, .intercom-app, #intercom-container'
        );
        const toggle = hide ? 'none' : 'block';
        intercom && (intercom.style.display = toggle);
    };

    const getFormNameFromUrl = url => {
        return getHashFromURL(url).split('|')[1];
    };

    const escapeHandler = e => {
        if (e.key === 'Escape') {
            const activeTooltips = document.querySelectorAll('.js-show-tooltip-dialog');
            if (activeTooltips.length === 0) {
                hide();
            }
        }
    };

    const showWaitingSpinner = lightboxWrapper => {
        if (!lightboxWrapper) return;

        const spinnerContainer = document.createElement('div');
        spinnerContainer.className =
            'vwo-spinner-container tw:fixed tw:top-0 tw:left-0 tw:w-screen tw:h-screen tw:z-[1100] tw:overflow-y-scroll tw:overflow-x-hidden';
        ReactDOM.render(React.createElement(Loader), spinnerContainer);
        lightboxWrapper.appendChild(spinnerContainer);
    };

    const hideWaitingSpinner = lightboxWrapper => {
        const spinner = lightboxWrapper.querySelector('.vwo-spinner-container');
        if (spinner) lightboxWrapper.removeChild(spinner);
    };

    const init = (e, url) => {
        targetFile = getFormNameFromUrl(url);
        clickHandler(e);
        document.addEventListener('keydown', escapeHandler);
    };

    return {
        init,
    };
}
